// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","footer_items_holder":"Footer_footer_items_holder__NB6YI","footer_item":"Footer_footer_item__nqgZq"};